import React, { Fragment, useEffect, useState, useCallback } from 'react';
import useStores, { observer } from "stores";
import { Card, Button, Select } from 'antd';
import ImgView from 'components/common/FileController/ImgView';
import { COMPANY_TYPE } from 'constant';

const GoodsList = ({ onSelect, detailGoods, cGbn }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // 초기 화면 넓이 설정
  const { orderStore, goodsGroupStore } = useStores();
  const [goodsGroupCd, setGoodsGroupCd] = useState('');

  useEffect(() => {
    orderStore.orderGoodsList('', '', '', true);
    
    (cGbn === COMPANY_TYPE.BENZ) && goodsGroupStore.disGoodsGroupList(null, null, 'N');

    window.addEventListener('resize', handleResize); // resize 이벤트 리스너 추가
    return () => {
      window.removeEventListener('resize', handleResize); // 컴포넌트 언마운트 시 리스너 제거
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleResize = useCallback(() => {
    setWindowWidth(window.innerWidth);  // 리사이즈 처리 로직
  }, []);

  const TextContainer = (gdNm) => {
    let fontSize = 16;
    const titleWidth = ((windowWidth * 0.7)-370)/5;
    
    // 글씨 넓이 구하기
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = fontSize;
    const metrics = context.measureText(gdNm);
    const gdNmWidth = metrics.width;// gdNm.length ;

    if(gdNmWidth >= titleWidth && gdNmWidth < titleWidth*2) {
      fontSize = 12;
    } else if(gdNmWidth >= titleWidth*2 && gdNmWidth < titleWidth*3) {
      fontSize = 10;
    } else if(gdNmWidth >= titleWidth*3) {
      fontSize = 8;
    } else {
      if(gdNm?.split(`\n`).length > 2) {
        fontSize = 12;
      }
    }
    
    return (
      <div
        style={{
          // width: 'calc((100%) - 8px)',
          height: '50px',
          whiteSpace: "pre-wrap",
          overflowWrap: 'break-word', /* 긴 단어 줄바꿈 처리 */
          overflow: 'hidden', /* 내용이 넘칠 경우 숨김 처리 */
          display: 'flex',/* flexbox 사용 */
          alignItems: 'center',/* 세로 중앙 정렬 */
          textOverflow: 'ellipsis',
          //justifyContent: 'center',/* 가로 중앙 정렬 */
          //textAlign: 'center',  /* 텍스트 가운데 정렬 */
          fontSize: `${fontSize}px`, // state로 관리되는 글꼴 크기 적용
          lineHeight: '1.2',/* 줄 간격 */
        }}
      >
        {gdNm.split(`\n`).map((item, idx)=>{
          return (
            <Fragment key={idx}>
              {item}
              {gdNm.split(`\n`).length > idx+1 && <br />}
            </Fragment>
        )})}
      </div>
    );
  };

  const goodsCard = (item, idx) => {
    if(cGbn === COMPANY_TYPE.BENZ && goodsGroupCd !== '' && goodsGroupCd !== item.pGdCd) return;
    return (
      <Card.Grid
        key={idx}
        hoverable={false} 
        className={(detailGoods?.gdCd === item?.gdCd && detailGoods?.pGdCd === item?.pGdCd) 
          ? "item_unip_card on" : "item_unip_card"}
      >
        <Card
          title={TextContainer(item.gdNm)}
          hoverable
          cover={
            item?.gdImgUrlInfo_fileId &&
            <Fragment>
              <ImgView
                viewGlass={true}
                fileInfo={{
                  fileId: item.gdImgUrlInfo_fileId,
                  fileName: item.gdImgUrlInfo_fileName,
                  physicalName: item.gdImgUrlInfo_physicalName,
                  serverSubPath: item.gdImgUrlInfo_serverSubPath,
                }}
                detailFileInfo={{
                  fileId: item?.gdDetailUrlInfo_fileId,
                  fileName: item?.gdDetailUrlInfo_fileName,
                  physicalName: item?.gdDetailUrlInfo_physicalName,
                  serverSubPath: item?.gdDetailUrlInfo_serverSubPath,
                }}
              />
            </Fragment>
          }
          actions={[<Button type="primary" onClick={()=>onSelect(item)} >선택</Button>]}
        >
          {/* <Card.Meta title={item.pGdNm} description={item.gdNm} /> */}
        </Card>
      </Card.Grid>
    )
  }

  return (
    <Fragment>
      <div className="button-group">
        <h2>▶ 주문가능 근무복</h2>
        {cGbn === COMPANY_TYPE.BENZ &&
          <div className="button-right">
            <ul>
              <li><h3 style={{alignItems: 'center',display: 'flex', height: 32, color: 'blue' }}>직군구분</h3></li>
              <li>
                <Select
                  style={{ width: 200 }}
                  placeholder="직군구분"
                  value={goodsGroupCd}
                  onChange={(value)=>setGoodsGroupCd(value)}
                >
                  <Select.Option key={''}>전체</Select.Option>
                  {goodsGroupStore?.goodsGroupList.map(item=>
                    <Select.Option key={item.groupCd}>{item.groupNm}</Select.Option>)}
                </Select>
              </li>
            </ul>
          </div>
        }
      </div>
      <Card>
        {/* {orderStore?.goodsList?.length <= 0 
        ? <h4 style={{ color: 'red' }}>주문가능 한 근무복이 없습니다.</h4> */}
        {orderStore?.goodsList.map((item, idx)=>(
          goodsCard(item, idx)
          
        ))}
      </Card>
    </Fragment>
  );
}

export default observer(GoodsList);
